"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdvancedSearch = void 0;
const react_1 = require("react");
const AdvancedSearchHelper_1 = require("../utils/AdvancedSearchHelper");
const Constants_1 = require("../utils/Constants");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
/**
 * Hook for handling advanced search functionality
 * Shared between web and mobile apps
 */
const useAdvancedSearch = ({ chatManager, advanceSearchFilters, selectedDistance, selectedDiscipline, departments, }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const isLoadingRef = (0, react_1.useRef)(false);
    const getPayload = (0, react_1.useCallback)(() => {
        if (!advanceSearchFilters)
            return null;
        return (0, AdvancedSearchHelper_1.buildAdvanceSearchPayload)({
            advanceSearchFilters,
            selectedDistance,
            selectedDiscipline,
            departments,
        });
    }, [advanceSearchFilters, selectedDistance, selectedDiscipline, departments]);
    const fetchAdvanceSearchData = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext, patientChatManager, payload) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            isLoadingRef.current = true;
            setIsLoading(true);
            yield patientChatManager.fetchAdvanceSearchClinicianList(payload, abortContext);
        }
        finally {
            isLoadingRef.current = false;
            setIsLoading(false);
        }
    }), Constants_1.Constants.API_DEBOUNCE_DELAY_IN_MS, [advanceSearchFilters, selectedDiscipline, selectedDistance]);
    const fetchData = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (isLoadingRef.current)
            return;
        const payload = getPayload();
        if (chatManager && payload) {
            yield fetchAdvanceSearchData(chatManager, payload);
        }
    }), [chatManager, getPayload, fetchAdvanceSearchData]);
    const resetData = (0, react_1.useCallback)(() => {
        chatManager === null || chatManager === void 0 ? void 0 : chatManager.resetAdvanceSearchClinicianList();
    }, [chatManager]);
    // Reset data when search location changes
    (0, react_1.useEffect)(() => {
        chatManager === null || chatManager === void 0 ? void 0 : chatManager.resetAdvanceSearchClinicianList();
    }, [advanceSearchFilters, chatManager]);
    // Fetch data when filters change
    (0, react_1.useEffect)(() => {
        fetchData();
    }, [fetchData]);
    // Reset data on unmount
    (0, react_1.useEffect)(() => {
        return () => {
            resetData();
        };
    }, [resetData]);
    return {
        isLoading,
        fetchData,
        resetData,
    };
};
exports.useAdvancedSearch = useAdvancedSearch;
